import React from 'react';
import './BlogPart.css';
import Blog1 from './assets/blog-1.jpeg';
import Blog2 from './assets/blog-2.jpeg';
import Blog3 from './assets/blog-3.jpeg';

function BlogPart(){
    return(
        <div className='container blog-part pt-5 pb-5' id='blog'>
            <div>
                <h2 className='products-heading pb-5'>Our Latest Posts</h2>
            </div>
            <div className='blog-part-row row'> 
                <div className='blog-col col-12 col-sm-12 col-md-4 col-lg-4 pb-4'>
                    <div className='blog-card'>
                        <div className='blog-img'>
                            <img src={Blog1} className='fluid-image'/>
                        </div>
                        <div className='blog-details pt-2'>
                            <a href='#'><h3 className='blog-title'>Best laptops under $500</h3></a>
                            <p>Published on: 15 Jan, 2024</p>
                        </div>
                    </div>
                </div>
                <div className='blog-col col-12 col-sm-12 col-md-4 col-lg-4 pb-4'>
                    <div className='blog-card'>
                        <div className='blog-img'>
                            <img src={Blog2} className='fluid-image'/>
                        </div>
                        <div className='blog-details pt-2'>
                            <a href='#'><h3 className='blog-title'>How to cool a gaming laptop</h3></a>
                            <p>Published on: 15 Jan, 2024</p>
                        </div>
                    </div>
                </div>
                <div className='blog-col col-12 col-sm-12 col-md-4 col-lg-4 pb-4'>
                    <div className='blog-card'>
                        <div className='blog-img'>
                            <img src={Blog3} className='fluid-image'/>
                        </div>
                        <div className='blog-details pt-2'>
                            <a href='#'><h3 className='blog-title'>How to clean a laptop</h3></a>
                            <p>Published on: 15 Jan, 2024</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlogPart;